// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3TrHs","select":"Header_select__qO6xg","clinic":"Header_clinic__1vBHE"};